import { instance } from './instance';
import type {
  CompanyListParams,
  CompanyListResponse,
  CompanyStatus,
  CompanySummary,
} from '../types';

export const companiesApi = {
  listCompanies: async (
    params: CompanyListParams,
  ): Promise<CompanyListResponse> =>
    (await instance.get('/company', { params })).data,

  changeCompanyStatus: async (
    id: string,
    status: CompanyStatus,
  ): Promise<CompanySummary> =>
    (await instance.patch(`/company/${id}/status`, { status })).data.data,
};
